import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { startCase } from 'lodash';

export const initialState: initialStateType = {
  id: '',
  avatar: '',
  name: '',
  userName: '',
  email: '',
  authority: [],
  userRole: null,
};

export const userSlice = createSlice({
  name: 'auth/user',
  initialState,
  reducers: {
    userLoggedOut: () => initialState,
    setUser: (state, action: PayloadAction<initialStateType>) => {
      state.id = action.payload.id;
      state.avatar = action.payload.avatar;
      state.name = startCase(action.payload.name);
      state.userName = action.payload.userName;
      state.email = action.payload.email;
      state.authority = action.payload.authority;
    },
  },
});

export const { setUser } = userSlice.actions;
export default userSlice.reducer;
interface initialStateType {
  id: string;
  avatar: string;
  name: string;
  userName: string;
  email: string;
  authority: string[]; // ['ADMIN', 'SOME_OTHER_ROLE', 'ETC]
  userRole: { label: string; value: string } | null;
}
